
export default
    name: "sport-icon"
    props:
        sport: String
        required: true

    methods:
        sportIcon: (sport) ->
            switch sport
                when 'running' then 'fa-running'
                when 'swimming' then 'fa-swimmer'
                when 'cycling' then 'fa-bicycle'
                when 'triathlon' then 'fa-triangle'
                when 'skiing' then 'fa-skiing-nordic'
                when 'swimrun' then 'fa-swimmer'
                when 'transit' then 'fa-flag-checkered'
                else 'fa-running'


